function createImageZoomPop(image) {
  const imageBounds = image.getBoundingClientRect();
  const edgeSpace = 10;
  const widthScale = 680 / imageBounds.width;
  const heightScale = (window.innerHeight * 0.82) / imageBounds.height;
  const scale = Math.max(1, Math.min(1.2, widthScale, heightScale));
  const width = imageBounds.width * scale;
  const height = imageBounds.height * scale;
  const zoomFrame = document.createElement('div');
  const zoomedImage = document.createElement('img');
  let left = imageBounds.left - (width - imageBounds.width) / 2;
  let top = imageBounds.top - (height - imageBounds.height) / 2;

  left = Math.min(window.innerWidth - width - edgeSpace, Math.max(edgeSpace, left));
  top = Math.min(window.innerHeight - height - edgeSpace, Math.max(edgeSpace, top));

  zoomFrame.className = 'image-magnify-pop';
  zoomFrame.setAttribute('aria-hidden', 'true');
  zoomFrame.style.left = `${left}px`;
  zoomFrame.style.top = `${top}px`;
  zoomFrame.style.width = `${width}px`;
  zoomFrame.style.height = `${height}px`;

  zoomedImage.className = 'image-magnify-pop__image';
  zoomedImage.src = image.currentSrc || image.src;
  zoomedImage.alt = '';
  zoomedImage.style.width = `${width * 1.4}px`;
  zoomedImage.style.height = `${height * 1.4}px`;
  zoomedImage.style.objectPosition = getComputedStyle(image).objectPosition;
  zoomFrame.appendChild(zoomedImage);
  document.body.appendChild(zoomFrame);

  return zoomFrame;
}

function moveInsideZoomPop(image, zoomFrame, event) {
  const imageBounds = image.getBoundingClientRect();
  const zoomedImage = zoomFrame.querySelector('.image-magnify-pop__image');
  const xPercent = Math.min(1, Math.max(0, (event.clientX - imageBounds.left) / imageBounds.width));
  const yPercent = Math.min(1, Math.max(0, (event.clientY - imageBounds.top) / imageBounds.height));
  const overflowX = zoomedImage.offsetWidth - zoomFrame.offsetWidth;
  const overflowY = zoomedImage.offsetHeight - zoomFrame.offsetHeight;

  zoomedImage.style.transform = `translate(${-overflowX * xPercent}px, ${-overflowY * yPercent}px)`;
}

function enableZoomOnHover() {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  document.querySelectorAll('.image-magnify-hover').forEach((image) => {
    if (image.dataset.zoomOnHoverInitialized === 'true') return;

    image.dataset.zoomOnHoverInitialized = 'true';
    let zoomFrame;

    image.addEventListener('mouseenter', (event) => {
      zoomFrame = createImageZoomPop(image);
      moveInsideZoomPop(image, zoomFrame, event);
    });
    image.addEventListener('mousemove', (event) => {
      if (zoomFrame) moveInsideZoomPop(image, zoomFrame, event);
    });
    image.addEventListener('mouseleave', () => {
      zoomFrame?.remove();
      zoomFrame = undefined;
    });
  });
}

enableZoomOnHover();
